import React from 'react';
import DriveSourceIcon from '@/assets/DriveSource Favicon White.svg';

interface QuickSuggestionsBlockProps {
    topLine: string;
    title: string;
    subtitle?: string;
    suggestions: string[];
    onSend: (message: string) => void;
}

export const QuickSuggestionsBlock: React.FC<QuickSuggestionsBlockProps> = ({
    topLine,
    title,
    subtitle = 'Start the conversation below',
    suggestions,
    onSend,
}) => (
    <div className="my-4">
        <p className="text-xs text-gray-400 font-medium mb-0.5">{topLine}</p>
        <p className="text-sm text-white font-semibold mb-0.5">{title}</p>
        <p className="text-xs text-gray-400 mb-3">{subtitle}</p>
        <div className="grid grid-cols-2 gap-2">
            {suggestions.map((s, i) => (
                <button
                    key={i}
                    onClick={() => onSend(s)}
                    className="flex items-center gap-1.5 px-3 sm:px-4 py-2.5 sm:py-2 rounded-3xl border border-gray-500 bg-[#2d2d2d] text-gray-300 text-xs sm:text-sm hover:border-gray-300 hover:text-white transition-colors w-full min-h-[44px] sm:min-h-0 text-left"
                >
                    <img src={DriveSourceIcon} alt="" className="w-3 h-3 sm:w-3.5 sm:h-3.5 flex-shrink-0 object-contain" />
                    <span className="leading-tight">{s}</span>
                </button>
            ))}
        </div>
    </div>
);
